import { useRef, useState } from "react";
import { TASKBAR_HEIGHT, beginDrag, clamp, loadJSON, saveJSON } from "../utils/desktop";

// Movement below this many pixels is treated as a click, so double-clicking never nudges the icon.
const DRAG_THRESHOLD = 4;

const loadOffset = (key) => {
  const o = loadJSON(key);
  return o && Number.isFinite(o.x) && Number.isFinite(o.y) ? o : { x: 0, y: 0 };
};

const DesktopIcon = ({ name, iconSrc, onOpen, selected, onSelect }) => {
  const storageKey = `desktop-icon:${name}`;
  const [offset, setOffset] = useState(() => loadOffset(storageKey));
  const draggedRef = useRef(false);

  const handlePointerDown = (e) => {
    onSelect();
    draggedRef.current = false;
    const o0 = offset;
    const b = e.currentTarget.getBoundingClientRect();
    const minX = o0.x - b.left;
    const maxX = o0.x + window.innerWidth - b.right;
    const minY = o0.y - b.top;
    const maxY = o0.y + window.innerHeight - TASKBAR_HEIGHT - b.bottom;
    let next = o0;

    beginDrag(
      e,
      (dx, dy) => {
        if (!draggedRef.current && Math.abs(dx) + Math.abs(dy) < DRAG_THRESHOLD) return;
        draggedRef.current = true;
        next = { x: clamp(o0.x + dx, minX, maxX), y: clamp(o0.y + dy, minY, maxY) };
        setOffset(next);
      },
      () => saveJSON(storageKey, next)
    );
  };

  return (
    <div
      className="
        flex flex-col items-center justify-center cursor-pointer
        w-[6rem] h-[7rem] select-none touch-none
      "
      style={{ transform: `translate(${offset.x}px, ${offset.y}px)` }}
      data-desktop-icon
      onPointerDown={handlePointerDown}
      onDoubleClick={() => onOpen && !draggedRef.current && onOpen()}
    >
      <div className="relative w-[3rem] h-[3rem]">
        <img src={iconSrc} alt={name} className="w-full h-full [image-rendering:pixelated]" draggable={false} />
        {selected && (
          // Win98 dithers navy over the icon's opaque pixels only, so the icon itself is the mask.
          <div
            className="absolute inset-0"
            style={{
              background: "repeating-conic-gradient(#000080 0 25%, transparent 0 50%) 0 0 / 2px 2px",
              WebkitMask: `url("${iconSrc}") center / contain no-repeat`,
              mask: `url("${iconSrc}") center / contain no-repeat`,
            }}
          />
        )}
      </div>
      <p
        className={`
          text-white text-center  text-[1.7em] mt-2 px-1
           max-w-[6rem]  leading-[0.8]
          -webkit-box -webkit-box-orient-vertical -webkit-line-clamp-2
          ${selected ? "bg-[#000080] outline-dotted outline-1 outline-[#ffff7f]" : ""}
        `}
        title={name}
      >
        {name}
      </p>
    </div>
  );
};

export default DesktopIcon;
